import Vue from 'vue'

const initialState = {
  list: [],
  employeeList: [],
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    DELETE_ANNOUNCEMENT(state, id) {
      state.list = state.list.filter((announcement) => announcement.id !== id)
    }
  },
  actions: {
    getList({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`announcement/announcements/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data.results})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit, state}, survey) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`announcement/announcements/`, survey).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, announcementId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.delete(`announcement/announcements/${announcementId}/`).then(() => {
          commit('DELETE_ANNOUNCEMENT', announcementId)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getEmployeeList({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/employees/search/?scope=all`).then(response => {
          commit('SET', {key: 'employeeList', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
